
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-town/confirmation",
      function () {
        return require("private-next-pages/token-town/confirmation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-town/confirmation"])
      });
    }
  